import React from "react";
import { PurchaseCharterFromQuery } from "view/charters/PurchaseCharterDetails";
import PurchaseCharterDetailsBlock from "./PurchaseCharterDetailsBlock";
import PurchaseCharterInfoBlock from "./PurchaseCharterInfoBlock";
import PurchaseCharterVoyagesBlock from "./PurchaseCharterVoyagesBlock";
import { Height, LoadingBlock } from "../Blocks";
import { getCharterTypeColor } from "view/charters/utils/CharterUtils";

type UsePurchaseCharterBlockProps = {
	charter?: PurchaseCharterFromQuery
	loading: boolean;
	refetch: () => void;
	onDelete: () => void;
	onSelect?: (voyageId: number | undefined) => void;
};

const usePurchaseCharterBlock = ({ charter, loading, refetch, onDelete, onSelect }: UsePurchaseCharterBlockProps) => {

	return {
		purchaseCharterBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Medium} />
				);
			} else if (charter) {
				return (
					<PurchaseCharterDetailsBlock
						charter={charter}
						color={getCharterTypeColor(charter.type, charter.subtype)}
						refetch={refetch}
						onDelete={onDelete} />
				);
			} else {
				return <React.Fragment />;
			}
		}(),

		purchaseCharterInfoBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Auto} />
				);
			} else if (charter) {
				return (
					<PurchaseCharterInfoBlock
						charter={charter}
						voyage={charter.voyages?.[0]}
						color={getCharterTypeColor(charter.type, charter.subtype)} />
				);
			} else {
				return (
					<React.Fragment />
				);
			}
		}(),

		purchaseCharterVoyagesBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Auto} />
				);
			} else if (charter) {
				return (
					<PurchaseCharterVoyagesBlock
						voyages={charter.voyages || []}
						color={getCharterTypeColor(charter.type, charter.subtype)}
						loading={loading}
						refetch={refetch}
						onSelect={onSelect} />
				);
			} else {
				return (
					<React.Fragment />
				);
			}
		}(),
	};
};

export default usePurchaseCharterBlock;
